import { ComponentProps } from 'react';
import StatusLabel from 'app/developer-v3/components/StatusLabel';
import { VersionLifecycleStatus } from 'app/developer-v3/types/statuses';

export const STATUS_LABEL_VARIANT_MAP: Record<
  VersionLifecycleStatus,
  ComponentProps<typeof StatusLabel>['variant']
> = {
  [VersionLifecycleStatus.promoted]: 'success',
  [VersionLifecycleStatus.private]: 'UiPrimaryWeakest',
  [VersionLifecycleStatus.draft]: 'UiPrimaryWeakest',
  [VersionLifecycleStatus.available]: 'GrayWarm3',
  [VersionLifecycleStatus.legacy]: 'default',
  [VersionLifecycleStatus.deprecating]: 'warning',
  [VersionLifecycleStatus.deprecated]: 'error',
};

export const STATUS_TOOLTIP_MAP: Record<VersionLifecycleStatus, string> = {
  [VersionLifecycleStatus.private]:
    'Default status when creating new versions. Users will not see this version unless invited.',
  [VersionLifecycleStatus.draft]:
    'Default status when creating new versions. Users will not see this version unless invited.',
  [VersionLifecycleStatus.promoted]:
    'Represents the latest working version. Visible to all users and is the default version for new automations.',
  [VersionLifecycleStatus.available]:
    'Automations using this version will continue to work. Maintainers and invited users may still select this version for new automations.',
  [VersionLifecycleStatus.legacy]:
    'Automations using this version will continue to work. Users will not be able to select this version for new automations.',
  [VersionLifecycleStatus.deprecating]:
    'Automations using this version will continue to work until deprecation date. Users will not be able to select this version for new automations.',
  [VersionLifecycleStatus.deprecated]:
    'Automations using this version will stop working.',
};
